import classnames from 'classnames';
import React from 'react';
import { Icon } from '@tcc/crate';
import styles from '../scoutingForm.css';

export type ScoutingFormListItemProps = {
  children: React.ReactNode;
  subtitle?: string;
  icon?: JSX.Element;
  showArrow?: boolean;
  selected?: boolean;
  content?: React.ReactNode;
  clickable?: boolean;
  onClick?: () => void;
  className?: string;
}

export const ScoutingFormListItem = ({
  icon,
  showArrow = false,
  children,
  selected = false,
  clickable = false,
  subtitle,
  content,
  onClick,
  className = ''
}: ScoutingFormListItemProps) => (
  <div
    className={classnames(
      styles.modalRow,
      styles.formItemContainer,
      content ? styles.formListItemExpandable : '',
      clickable || onClick ? styles.cursorPointer : '',
      clickable || onClick ? styles.formItemContainerSelectable : '',
      selected ? styles.formListItemSelected : '',
      className
    )}
    data-test-id="enhanced-scouting-form-list-item"
    onClick={onClick}
  >
    <div className={classnames(
      styles.formItemMainContainer,
      content ? styles.formItemMainContainerExpandable : ''
    )}
    >
      {icon}
      <div className={styles.formItemMainContent}>
        {children}
        {subtitle && <span className={styles.formItemSubtitle}>
          {subtitle}
        </span>}
      </div>
      {showArrow && <Icon
        glyph={Icon.set.ARROW_RIGHT}
        className={styles.formListItemIcon}
        testId="enhanced-scouting-form-list-item-arrow"
      />
      }
      {selected && <Icon
        glyph={Icon.set.CHECK}
        className={styles.formListItemIcon}
        testId="enhanced-scouting-form-list-item-selected"
      />}
    </div>
    {content &&
      <div className={styles.formItemContainerContent} data-test-id="enhanced-scouting-form-list-item-content">
        {content}
      </div>}
  </div>
);
